export default __webpack_public_path__ + "static/PAPC-833-a16769a54c9775002713bb17b249d2cf.jpg";